import {PasswordPage} from './../password/password';
import {Component} from '@angular/core';
import {NavController, AlertController, LoadingController} from 'ionic-angular';
import {AuthService} from './../../../services/auth';
import {RegisterPage} from '../register/register';
import {TabsPage} from './../../tabs/tabs';
import {ClassesService} from './../../../services/classes';
import {SessionService} from '../../../services/session';

@Component({
  selector: 'page-sign-in',
  templateUrl: 'sign-in.html'
})
export class SignInPage {

  registerPage = RegisterPage;
  passwordPage = PasswordPage;
  tabsPage = TabsPage;
  showPassword = false;

  constructor(public navCtrl: NavController,
              public authService: AuthService,
              public alertCtrl: AlertController,
              public loadingCtrl: LoadingController,
              public classesService: ClassesService,
              public sessionService: SessionService) {
  }

  changeShowPassword() {
    this.showPassword = !this.showPassword;
  }

  onSignIn(form) {
    let loading = this.loadingCtrl.create({
      content: 'Iniciando sesión...'
    });
    loading.present()
    this.authService.logIn(form.value)
      .then(() => {
        this.navCtrl.setRoot(this.tabsPage);
        loading.dismiss();
      })
      .catch(err => {
        this.sessionService.reportError(
          'signInPage',
          'onSignIn()',
          err,
          form.value.email
        );
        let alert = this.alertCtrl.create({
          title: 'Error al iniciar sesión',
          message: err,
          buttons: [
            {
              text: 'Ok',
            }
          ]
        });
        loading.dismiss();
        alert.present();
      })
  }

  goTo(page) {
    this.navCtrl.push(page);
  }

  ionViewDidLoad() {
    window['page'] = 'SignInPage'; // for GA
    this.signinWithParams();
  }

  signinWithParams() {
    let email = this.getUrlParameter('email') || this.getUrlParameter('user');
    let password = this.getUrlParameter('password');
    if (email && password) {
      let form = {value: {email, password}};
      this.onSignIn(form);
    }
  }

  getUrlParameter(param) {
    let result;
    let params = location.pathname.substr(1).split('&');
    console.log(params);
    for (let i = 1; i < params.length; i++) {
      let t = params[i].split('=');
      if (t[0] === param) {
        result = decodeURIComponent(t[1]);
        break
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/sign-in/sign-in.ts